import React, { useEffect, useState } from "react";
import {
  Stack,
  Title,
  Loader,
  Text,
  Alert,
  Button,
  Group,
} from "@mantine/core";
import { useCampaign } from "../../context/CampaignContext";

function ComplianceCheckStep() {
  const { checkCompliance, setStep, complianceErrors, complianceWarnings } =
    useCampaign();
  const [checking, setChecking] = useState(true);
  const [passed, setPassed] = useState(false);

  useEffect(() => {
    const runCheck = async () => {
      setChecking(true);
      const passOrFail = await checkCompliance();
      setChecking(false);
      if (passOrFail === "pass") {
        setPassed(true);
        setStep(5); // Final review step
      } else if (passOrFail === "fail") {
        setPassed(false);
      } else {
        console.error("Unexpected compliance status:", passOrFail);
      }
    };
    runCheck();
  }, [checkCompliance, setStep]);

  if (checking) {
    return (
      <Stack
        gap="md"
        align="center"
        justify="center"
        style={{ minHeight: 320 }}
      >
        <Title order={3}>Compliance Check</Title>
        <Loader size="lg" />
        <Text>Running compliance check on your message...</Text>
      </Stack>
    );
  }

  if (passed) {
    return null;
  }

  return (
    <Stack gap="md" style={{ minHeight: 320 }}>
      <Title order={3}>Compliance Check Failed</Title>
      {complianceErrors.length > 0 && (
        <Alert color="red" title="Compliance Errors">
          {complianceErrors.map((error, index) => (
            <Text key={index} size="sm">
              • {error}
            </Text>
          ))}
        </Alert>
      )}
      {complianceWarnings.length > 0 && (
        <Alert color="yellow" title="Compliance Warnings">
          {complianceWarnings.map((warning, index) => (
            <Text key={index} size="sm">
              • {warning}
            </Text>
          ))}
        </Alert>
      )}
      <Group justify="flex-start" mt="md">
        <Button variant="default" onClick={() => setStep(3)}>
          &larr; Back to Edit Message
        </Button>
      </Group>
    </Stack>
  );
}

export default ComplianceCheckStep;
